import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { RESULTS_NOT_FOUND, ENDORSEMENT_MSGS, FORM_MSGS, FILE_UPLOAD_CONFIG } from 'src/app/_common/product-config';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateParserFormatter, NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Endorsement, EndorsementMethod } from '../_models/endorsement';
import { EndorsementBasicInfoComponent } from '../endorsement-basic-info/endorsement-basic-info.component';
import { EndorsementUnderwritingFormComponent } from '../endorsement-underwriting-form/endorsement-underwriting-form.component';
import { EndorsementService } from '../_services/endorsement.service';
import { EndorsementSteps, Modules} from 'src/app/_common/_enum/module.enum';
import { EndorsementReviewComponent } from '../endorsement-review/endorsement-review.component';
import { environment } from 'src/environments/environment';
import LogRocket from 'logrocket';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-request-endorsement',
  templateUrl: './request-endorsement.component.html',
  styleUrls: ['./request-endorsement.component.scss']
})

export class RequestEndorsementComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  public policyNumber;
  private selectedPolicy;
  private selectedAccount;

  public loading: boolean = false; //Using it in HTML
  private submitLoading: boolean = false;
  private hasAccess: boolean = true; //Using it in HTML
  //private selectedStep: string = EndorsementSteps.BasicInfo; //Using it in HTML

  private endorsementSteps = EndorsementSteps;

  private resultsNotFound = RESULTS_NOT_FOUND; //Using it in HTML
  private endorsementMsgs = ENDORSEMENT_MSGS; //Using it in HTML
  private formMsgs = FORM_MSGS; //Using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML

  private _endorsement: Endorsement;
  private _endorsementMethods: EndorsementMethod;

  public isSubmitted: boolean = false;
  
  private modalReference;

  private uploadedFileSize: number = 0;

  @ViewChild(EndorsementBasicInfoComponent, {static: false}) endorsementBasicInfo:EndorsementBasicInfoComponent;
  @ViewChild(EndorsementUnderwritingFormComponent, {static: false}) endorsementUnderwritingForm:EndorsementUnderwritingFormComponent;
  @ViewChild(EndorsementReviewComponent, {static: false}) endorsementReview:EndorsementReviewComponent;

  @ViewChild("cancelEndorsementModal", {static: false}) cancelEndorsementModal;
  constructor(public readonly route: ActivatedRoute, private readonly router: Router, private modalService : NgbModal, public endorsementService:EndorsementService, private commonService: CommonService) { }

  ngOnInit() {
    this._endorsementMethods = new EndorsementMethod();
    this.headerData = new HeaderData();
    this.endorsementService.setSupportingDocuments([]);
    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {
      this.policyNumber = params.get("id").toString();
            
      this._endorsement = new Endorsement();
      this.retrieveBasicHeaderData(); //Retrieve the basic details of policy and Set the Header..
      this.setHeaderData();
      this._endorsement.policyNumber = this.policyNumber;
      this._endorsement.accountNumber = this.selectedPolicy.accountNumber;
      
      /* let tempEndorsement =  (this.endorsementService.endorsement)?this.endorsementService.endorsement:null;
      if(tempEndorsement && tempEndorsement.policyNumber != this.policyNumber){
        this._endorsement = new Endorsement();
        this.retrieveBasicHeaderData(); //Retrieve the basic details of policy and Set the Header..
      }else{
        this._endorsement =  (this.endorsementService.endorsement)?this.endorsementService.endorsement:new Endorsement();
        this.selectedPolicy = this.endorsementService.getPolicyData();
        this.fetchPolicyLob();
        this.setHeaderData();
      } */

      this.endorsement = this._endorsement;
      if(this._endorsement.selectedStep){
        this.selectedStep = this._endorsement.selectedStep;
      }else{
        this._endorsement.selectedStep = EndorsementSteps.BasicInfo;
      }
    });
  }

  retrieveBasicHeaderData(){
    /* Setting Headers Starts */
    this.headerData = new HeaderData();

    this.selectedPolicy = this.endorsementService.getPolicyData();
    this.selectedAccount = this.endorsementService.getAccountData();
    this.hasAccess = this.commonService.checkPermission(Modules.PolicyEndtSubmit);
    if(this.hasAccess){
    if(!this.selectedPolicy || this.selectedPolicy.policyNumber !== this.policyNumber){
      this.loading = true;
        let accountByPolicySubscription =  this.endorsementService.fetchAccountByPolicy(this.policyNumber).subscribe(policy=>{
          this.selectedPolicy = policy;
          if(this.selectedPolicy){
            this.endorsementService.storeAccountData({"accountName": this.selectedPolicy.accountName, "accountNumber": this.selectedPolicy.accountNumber, "accountEndorsementsTab": ((this.selectedAccount && this.selectedAccount.accountEndorsementsTab != null)?this.selectedAccount.accountEndorsementsTab: null)});
          }
          this.endorsementService.storePolicyData(this.selectedPolicy);
          this.fetchPolicyLob();
          this.setHeaderData();
        }, error=>{
          this.loading = false;
          this.selectedPolicy = null;
          this.hasAccess = false;
        });

        this.endorsementService.runningServices.push(accountByPolicySubscription);
      }else{
        this.fetchPolicyLob();
        this.setHeaderData();
      }
    }
    /* Setting Headers Ended */
  }

  fetchPolicyLob(){
    this.loading = true;
    let policyLOBSubscription =  this.endorsementService.fetchPolicyLob(this.policyNumber).subscribe(response=>{
      this.loading = false;
      this._endorsement.policyNumber = this.policyNumber;
      this._endorsement.accountName = this.selectedPolicy.accountName;
      this._endorsement.accountNumber = this.selectedPolicy.accountNumber;
      if(response && response.canEndorse){
        this._endorsement.policyNicheName = response.niche;

        this._endorsement.policyLobType = response.lob;
        this._endorsement.policyCanEndorse = response.canEndorse;

        this._endorsement.policyCancelDate = response.policyCancelDate;
      }else{
        this.router.navigate(["policies/"+this.policyNumber]);
      }

      this._endorsement.policyEffectiveDate = this.selectedPolicy.policyEffectiveDate;
      this._endorsement.policyExpirationDate = this.selectedPolicy.policyExpirationDate;

      let _policyEffectiveDate = new Date(this._endorsement.policyEffectiveDate);

      if(this._endorsement.policyCancelDate){
        let _policyCancelDate = new Date(this._endorsement.policyCancelDate);
        _policyCancelDate.setDate(_policyCancelDate.getDate()-1);

        if(_policyCancelDate == _policyEffectiveDate || _policyCancelDate < new Date()){
          this.router.navigate(["policies/"+this.policyNumber+"/endorsements"]);
        }
      }else{
        let _policyExpirationDate = new Date(this._endorsement.policyExpirationDate);
        _policyExpirationDate.setDate(_policyExpirationDate.getDate()-1);
        if(_policyExpirationDate < new Date()){
          this.router.navigate(["policies/"+this.policyNumber+"/endorsements"]);
        }
      }
      
      this.endorsement = this._endorsement;
    }, error=>{
      this.loading = false;
    });
    this.endorsementService.runningServices.push(policyLOBSubscription);
  }
  setHeaderData(){
    this.headerData.pageTitle = "Endorsement Request";
    if(this.selectedPolicy){
      this.headerData.pageTitle = "Endorsement Request";
      this.headerData.breadcrumb = [{ itemName: this.selectedPolicy.accountName, itemLink:  "/accounts/" + this.selectedPolicy.accountNumber + "/endorsements"}, {itemName:this.selectedPolicy.policyNumber, itemLink:"policies/"+ this.selectedPolicy.policyNumber+"/endorsements"}];
    }
    this.endorsementService.header = this.headerData;
  }

  get selectedStep(){
    return this.endorsementService.selectedStep;
  }
  set selectedStep(_step){
    this._endorsement.selectedStep = _step;
    this.endorsementService.selectedStep = _step;
  }
  get endorsement(){
    return this.endorsementService.endorsement;
  }
  set endorsement(_endorsement){
    this.endorsementService.endorsement = _endorsement;
  }

  getUploadedFileSize($event) {
    this.uploadedFileSize = $event;
  }

  selectStep(_index, _step){
    if(this.selectedStep !== this.endorsementSteps.BasicInfo && _step == this.endorsementSteps.BasicInfo){
      this.selectedStep = _step;
    }else if(this.selectedStep === this.endorsementSteps.Review && _step != this.endorsementSteps.Review){
      this.selectedStep = _step;
    }

    this._endorsement.selectedStep = this.selectedStep;

    this.endorsement = this._endorsement;
  }

  public onContinue():void{
    this.isSubmitted = true;
    if(this.selectedStep == EndorsementSteps.BasicInfo){
      if(this.endorsementBasicInfo.onContinue()){
        this.selectedStep = this.endorsementSteps.UnderwritingNeeds;
        this.endorsement.selectedStep = this.endorsementSteps.UnderwritingNeeds;
        this.endorsement = this._endorsement;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid basic info continue");
      }
    }else if(this.selectedStep == EndorsementSteps.UnderwritingNeeds){
      if(this.endorsementUnderwritingForm.onContinue()){
        this.selectedStep = this.endorsementSteps.Review;
        this.endorsement.selectedStep = this.endorsementSteps.Review;
        this.endorsement = this._endorsement;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid basic info continue");
      }
    }else if(this.selectedStep == EndorsementSteps.Review){
      if(this.endorsementReview.onContinue()){
        this.endorsement = this._endorsement;
        window.scrollTo(0, 0);

        console.log("uploading files");
        let newSupportingDocuments = [];
        this.loading = true;
        this.submitLoading = true;
        if(this.endorsementService.getSupportingDocuments().length>0){
          this.endorsementService.getSupportingDocuments().forEach((document, index) => {
             let newFile:any = {};
              newFile.name= document.name;
              newFile.lastModified= document.lastModified;
              newFile.lastModifiedDate= document.lastModifiedDate;
              newFile.webkitRelativePath= document.webkitRelativePath;
              newFile.size= document.size;
              newFile.type= document.type;
              newFile.docFileType = document.docFileType;
  
              ((_document, _newFile)=>{
                let fReader = new FileReader();
                // Add complete behavior
                fReader.onload = ()=>{
                  _newFile.content = fReader.result;
                  _newFile.content = _newFile.content.split("base64,")[1];
  
                  //console.log(_newFile.content);
                  newSupportingDocuments.push(_newFile);
  
                  if(newSupportingDocuments.length == this.endorsementService.getSupportingDocuments().length){
                    this.submitRequest(newSupportingDocuments);
                  }else{
                    console.log("uploading file " + index);
                  }
                };
                fReader.readAsDataURL(_document);
              })(document, newFile);   
          });
          //this.submitRequest(this.endorsementService.getSupportingDocuments());
        }else{
          this.submitRequest([]);
        }
       // this.endorsement.supportingDocuments = newSupportingDocuments;

      }else{
        console.log("invalid basic info continue");
      }
    }
  }

  submitRequest(newSupportingDocuments){
    console.log("Submitting request");
    let finalEndorsement = this._endorsementMethods.getFinalEndorsement(this._endorsement);
    finalEndorsement.supportingDocuments = newSupportingDocuments;
    /*const formData = new FormData();
    formData.append("data", JSON.stringify(finalEndorsement));
    newSupportingDocuments.forEach(document => {
      formData.append("supportingDocuments", document);
    });*/
    this.endorsementService.submitEndorsement(this.policyNumber, finalEndorsement).subscribe(()=>{
      console.log("Submitted!!");
      
    if(environment.logRocketKey){
      LogRocket.log("(LogRocket) EndorsementRequestSubmitted : " + true);
      let loggedInUser = this.endorsementService.getLoggedInProfile();
      LogRocket.identify(loggedInUser.UID.toString(), {
        EndorsementRequestSubmitted: true
      });
    }
      this.selectedStep = this.endorsementSteps.Success;
      this.endorsement.selectedStep = this.endorsementSteps.Success;

      this._endorsement = new Endorsement();
      this._endorsement.selectedStep = this.endorsementSteps.Success;
      this.endorsement = this._endorsement;
      this.loading = false;
      this.submitLoading = false;
    },error=>{          
      this.loading = false;
      this.submitLoading = false;
    });
    console.log(JSON.stringify(finalEndorsement));
  }

  public onCancel(){
    this.modalReference = this.modalService.open(this.cancelEndorsementModal, { centered: true, backdropClass: 'light-blue-backdrop' });
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
  }

  cancelEndorsement(){
    if(environment.logRocketKey){
      LogRocket.log("(LogRocket) CancelEndorsement : " + true);
      let loggedInUser = this.endorsementService.getLoggedInProfile();
      LogRocket.identify(loggedInUser.UID.toString(), {
        CancelEndorsement: true
      });
    }
    this.modalReference.close();
    this.router.navigate(["policies/"+this.policyNumber+"/endorsements"]);
  }
}
